import { render, staticRenderFns } from "./modalEditarItens.vue?vue&type=template&id=701ce2a4&scoped=true&"
import script from "./modalEditarItens.vue?vue&type=script&lang=js&"
export * from "./modalEditarItens.vue?vue&type=script&lang=js&"
import style0 from "./modalEditarItens.vue?vue&type=style&index=0&id=701ce2a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701ce2a4",
  null
  
)

export default component.exports